<div class="meu-perfil">
  <div class="voltar-link">
    <button type="button" (click)="goBackToProfile()">
      <img
        src="{{
          BASE_IMG_URL
        }}assets/icons/arrow_circle_left.svg"
        alt="Voltar para Meu Perfil"
      />MEU PERFIL
    </button>
  </div>

  <div class="alterar-senha-container">
    <div class="form-card">
      <div class="form-header">
        <span class="material-icons form-icon">security</span>
        <div>
          <div class="form-title">Alterar Senha</div>
          <div class="form-desc">
            Mantenha sua conta segura atualizando sua senha periodicamente
          </div>
        </div>
      </div>

      <form [formGroup]="senhaForm" (ngSubmit)="changePassword()">
        <div class="form-group">
          <label for="senhaAtual">Senha atual</label>
          <div class="input-icon">
            <span class="material-icons">lock</span>
            <input
              id="senhaAtual"
              [type]="showCurrentPassword ? 'text' : 'password'"
              formControlName="senhaAtual"
              placeholder="Digite sua senha atual"
            />
            <span
              class="material-icons icon-eye"
              (click)="toggleShowPassword('atual')"
            >
              {{ showCurrentPassword ? "visibility_off" : "visibility" }}
            </span>
          </div>
        </div>

        <div class="form-group">
          <label for="novaSenha">Nova senha</label>
          <div class="input-icon">
            <span class="material-icons">lock</span>
            <input
              id="novaSenha"
              [type]="showNewPassword ? 'text' : 'password'"
              formControlName="novaSenha"
              placeholder="Digite sua nova senha"
            />
            <span
              class="material-icons icon-eye"
              (click)="toggleShowPassword('nova')"
            >
              {{ showNewPassword ? "visibility_off" : "visibility" }}
            </span>
          </div>
          <small class="login-info">Mínimo de 8 caracteres</small>
          <div
            *ngIf="
              senhaForm.get('novaSenha')?.touched &&
              senhaForm.get('novaSenha')?.hasError('senhaFraca')
            "
            class="erro-mensagem"
          >
            Use uma senha com letras maiúsculas e minúsculas, números e
            caracteres especiais.
          </div>
        </div>

        <div class="form-group">
          <label for="confirmarSenha">Confirmar nova senha</label>
          <div class="input-icon">
            <span class="material-icons">lock</span>
            <input
              id="confirmarSenha"
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confirmarSenha"
              placeholder="Confirme sua nova senha"
            />
            <span
              class="material-icons icon-eye"
              (click)="toggleShowPassword('confirmar')"
            >
              {{ showConfirmPassword ? "visibility_off" : "visibility" }}
            </span>
          </div>
          <div
            *ngIf="
              passwordsDoNotMatch && senhaForm.get('confirmarSenha')?.touched
            "
            class="erro-mensagem"
          >
            As senhas não conferem
          </div>
        </div>

        <button type="submit" class="btn-salvar" [disabled]="!isFormValid">
          <span class="material-icons">lock</span>
          {{ submitting ? "Alterando..." : "Alterar senha" }}
        </button>
      </form>
    </div>
  </div>
</div>
